import React, { lazy, Suspense } from 'react';

const LazyFamiliesView = lazy(() => import('./FamiliesView'));

const FamiliesView = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyFamiliesView {...props} />
  </Suspense>
);

export default FamiliesView;
